/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Topic_AuditInputs */



/**
* | output |
* | --- |
* | "Audit or assessment" |
*
* @param {Contact_Topic_AuditInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const contact_topic_audit = /** @type {((inputs?: Contact_Topic_AuditInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Topic_AuditInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("审核或评估")
	return /** @type {LocalizedString} */ ("Audit or assessment")
});